import { Text } from '@/components/ui/Text';

const TESTIMONIALS = [
  {
    quote:
      '\u201CJoining Sollis Health has been one of the best decisions I have made. Their facilities are impeccable; usually no wait times; the staff of nurses and physicians take time to listen and come up with a plan to get one feeling better.\u201D',
    name: 'Francisco, Sollis Member',
    className: 'bg-sh-paper h-full flex-1 rounded-4xl',
  },
  {
    quote:
      '\u201CWhether it\u2019s a routine concern or something more complex, I\u2019ve never felt alone or unheard. The level of personalized attention is unparalleled\u2014it\u2019s as if the entire team is genuinely invested in my health and well-being.\u201D',
    name: 'Alex, Sollis Member',
    className: 'bg-sh-paper h-full flex-1 rounded-4xl',
  },
  {
    quote:
      '\u201CSollis Health is amazing! From the moment you walk in the door, you immediately feel the difference. The doctors take their time with you, the staff is friendly, and what I really love is that they actually follow up to see how you are doing after they treat you.\u201D',
    name: 'Nick, Sollis Member',
    className: 'bg-sh-paper h-full flex-1 rounded-4xl',
  },
];

export function TestimonialsSection() {
  return (
    <div className='flex w-full justify-center'>
      <div className='mx-[30px] flex max-w-[1800px] flex-col gap-[64px] py-[64px] md:mx-[90px]'>
        <div className='mx-auto my-[16px]'>
          <Text variant='h1-serif' as='h3' className='text-center'>
            Trusted by Those Who Expect the Best
          </Text>
        </div>
        <div className='mx-[30px] flex flex-col gap-[40px] lg:mx-[50px] xl:flex-row'>
          {TESTIMONIALS.map((testimonial, index) => (
            <div key={index} className={testimonial.className}>
              <div className='m-[30px] my-[50px] flex flex-col gap-[20px] md:m-[48px]'>
                <Text variant='quote' as='p'>
                  {testimonial.quote}
                </Text>
                <Text variant='body' color='semidark'>
                  {testimonial.name}
                </Text>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
